import { render, staticRenderFns } from "./VirtualPosSelectbox.vue?vue&type=template&id=2cfb0d7a"
import script from "./VirtualPosSelectbox.vue?vue&type=script&lang=js"
export * from "./VirtualPosSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports